import request from '@/utils/axios_gispai'


export function getDataAll(params) {
    return request({
        url: 'api/GData/get_GDataall',
        method: 'get',
        params: params
    })
}

export function getDataVal(params) {
    return request({
        url: 'api/GData/get_GDatavalue',
        method: 'get',
        params: params
    })
}

export function getMapDocData(params) {
    return request({
        url: 'api/MapDoc/GetLayersByMapDocUnitCode',
        method: 'get',
        params: params
    })
}

export function get_mapdocdetails(params) {
    return request({
        url: 'api/MapDoc/get_mapdocdetails',
        method: 'get',
        params: params
    })
}
// export function get_mapdocdetails(params) {
//   return request({
//       url: `api/MapDoc/get_mapdocdetails/${params.Id}`,
//       method: 'get',
//       params: { UserId: params.UserId }
//   })
// }

export function getDataByTask(params) {
    return request({
        url: 'api/GData/get_GData_see_task',
        method: 'get',
        params: params
    })
}


export function getDataDetail(params) {
    return request({
        url: 'api/GData/get_GData',
        method: 'get',
        params: params
    })
}

export function updateTaskDataId(params) {
    return request({
        url: 'api/MapDoc/updateTaskdataid',
        method: 'get',
        params: params
    })
}

export function IsDataWarehousing(params) {
    return request({
        url: 'api/GData/IsDataWarehousing',
        method: 'get',
        params: params
    })
}

// 保存为地图
export function saveAsMapDoc(params) {
    return request({
        url: 'api/MapDoc/Generate_MapDoc',
        method: 'post',
        data: params
    })
}

// 更新地图范围
export function updateMapDocOfExtent(params) {
    return request({
        url: 'api/MapDoc/UpdateMapDocOfExtent',
        method: 'post',
        data: params
    })
}

// 更新数据范围
export function updateGDataOfExtent(params) {
    return request({
        url: 'api/GData/UpdateGDataOfExtents',
        method: 'post',
        data: params
    })
}


export function getLayerForCache(params) {
    return request({
        url: 'api/MapDoc/getLayerForCache',
        method: 'get',
        params: params
    })
}

// 设置为任务
export function setAsGDataTask(params) {
    return request({
        url: 'api/GData/setGDataTask',
        method: 'post',
        data: params
    })
}
// 设置为任务
export function setGDataTask(params) {
    return request({
        url: 'api/GData/setGDataTask_new',
        method: 'post',
        data: params
    })
}
export function setGDataTask_Encryption(params) {
    return request({
        url: 'api/GData/setGDataTask_Encryption',
        method: 'post',
        data: params
    })
}
// 复制我的数据
export function CopyGData(params) {
    return request({
        url: 'api/GData/CopyGData',
        method: 'get',
        params: params
    })
}
// 复制我的地图
export function CopyMapDoc(params) {
    return request({
        url: 'api/MapDoc/CopyMapDoc',
        method: 'get',
        params: params
    })
}

// 更新我的数据符号
export function UpdateGDataOfSymbol(params) {
    return request({
        url: 'api/GData/UpdateGDataOfSymbol',
        method: 'post',
        data: params
    })
}

//获取我的数据详情(华为云)
export function getGDataByOBS(params) {
    return request({
        url: 'api/GData/GetSingleGDataInfo',
        method: 'get',
        params: params
    })
}
//获取我的数据详情(华为云)
export function getGDataAttrByOBS(params) {
    return request({
        url: 'api/GData/get_GDataAttr_OBS',
        method: 'get',
        params: params
    })
}

//解绑片区
export function unbindGDataTask(params) {
    return request({
        url: 'api/GData/UnbindGDataTask',
        method: 'post',
        data: params
    })
}
export function CopyGDataSingle(params) {
    return request({
        url: 'api/GData/CopyGData',
        method: 'get',
        params: params
    })
}
/**项目 **/
//根据任务编号批量取数据
export function getBatchDataByProject(params) {
    return request({
        url: 'api/GData/get_GData_see_task_Project',
        method: 'get',
        params: params
    })
}
/** **/
//获取我的数据详情(华为云) 主题地图免费
export function getGDataByOBS_OpenMap(params) {
    return request({
        url: 'api/GData/GetSingleGDataInfo_openMap',
        method: 'get',
        params: params
    })
}
//获取我的数据详情(华为云)主题地图
export function getGDataByOBS_OpenMap_token(params) {
    return request({
        url: 'api/GData/GetSingleGDataInfo_openMap_token',
        method: 'get',
        params: params
    })
}
// 获取被绑定数据列表
export function getGData_bind(params) {
    return request({
        url: 'api/GData/GetGDataList',
        method: 'get',
        params: params
    })
}


export function getGdataPath(params) {
    return request({
        url: 'api/GeoDataFeature/getPath_Gdata',
        method: 'get',
        params: params
    })
}

// 数据加密
export function setDecryptKeys(params) {
    return request({
        url: 'api/GData/SetDecryptKeys',
        method: 'post',
        data: params
    })
}

// 更改数据的属性字段顺序
export function updateFieldOrder(params) {
    return request({
        url: 'api/GeoDataFeature/Updateorder_Field',
        method: 'post',
        data: params
    })
}

// 将地图数据另存为
export function copyGData_Save(params) {
    return request({
        url: 'api/GData/CopyGData_Save',
        method: 'post',
        data: params
    })
}

//获取数据详情
export function getDataDetail_GDB(params) {
    return request({
        url: '/api/GData/GetGDataInfoByMap',
        method: 'get',
        params: params
    })
}


export function updateGdataSetting(params) {
    return request({
        url: '/api/GData/UpdateGDataOfGSPTileAndMinscale',
        method: 'post',
        data: params
    })
}
export function getTry_NewMethod_reject(params) {
    return request({
        url: '/api/GData/GetTry_NewMethod_reject',
        method: 'get',
        params: params,

    })
}

export function getGDataObject(params, token) {
    return request({
        url: '/api/Edition/GetGDataObject',
        method: 'get',
        params: params,
        cancelToken: token
    })
}

export function getPointExtentGData(params) {
    return request({
        url: '/api/GData/GetPointExtentGData',
        method: 'get',
        params: params
    })
}

//按矩形选择
export function getRectangleExtentGData(params, token) {
    return request({
        url: '/api/GData/GetRectangleExtentGData',
        method: 'get',
        params: params,
        cancelToken: token
    })
}
//点击查询属性
export function getAttr(params) {
    return request({
        url: '/api/GeoDataFeature/getAttr',
        method: 'get',
        params: params
    })
}
//查询属性表
export function getTableAttr(params) {
    return request({
        url: '/api/GeoDataFeature/getallAttr',
        method: 'get',
        params: params
    })
}
//修改单个属性
export function updateSingleAttr(params) {
    return request({
        url: '/api/GeoDataFeature/updateAttrsingle',
        method: 'post',
        data: params
    })
}
//根据获取多条数据
export function getGeoDataFeatureBatch(params) {
    return request({
        url: '/api/GData/GetGeoDataFeaturebatch',
        method: 'post',
        data: params
    })
}

export function getTry_NewMethod_data(params, token) {
    return request({
        url: '/api/GData/GetTry_NewMethod_Data',
        method: 'get',
        params: params,
        cancelToken: token
    })
}
//GetOBSUploadUrl
export function GetOBSUploadUrl(params) {
    return request({
      url: '/api/GData/GetOBSUploadUrl',
      method: 'post',
      data: params
    })
}
  //api/UpLoadDown/UploadData
  export function UploadData(params) {
    return request({
      url: '/api/UpLoadDown/UploadData',
      method: 'post',
      data: params
    })
  }
  export function UploadXYData(params) {
    return request({
      url: '/api/UpLoadDown/UploadXYData',
      method: 'post',
      data: params
    })
  }
export function getEmapDetail(params){
    return request({
        url: 'api/EMap/GetEmapDetails',
        method: 'get',
        params: params
    })
}